import { Injectable } from "@angular/core";

import { RestServiceBase } from "@definitiv-packages/angular-dba-library";

import { TodoModel, TodoModelView} from "../../types/todo-model";


@Injectable({
    providedIn: 'root'
})
export class TodoService extends RestServiceBase<TodoModel> {
    constructor() { super("TodoModel"); } 
}